import type { RouterTabPath } from "src/lib/tabs/types.ts";

export const theEnd = (paths: RouterTabPath[]) => paths.length;
